module.exports = __webpack_public_path__ + "img/lp-NSF.383b9562.png";